import { mapActions, mapGetters } from 'vuex';

//---helpers
import { globalLoader } from '@/helpers/variables';

//---mixins
import { dynamicHead } from '@/mixins/dynamic-head.js';

//---components
import BreadcrumbsSimple from '@/components/@general/BreadcrumbsSimple/index.vue';

export default {
  name: 'Ingredients',
  mixins: [dynamicHead],
  components: { BreadcrumbsSimple },
  props: {},
  data() {
    return {
      letterArray: [],
      ingredientsData: null,
      selectedLetter: null,
      ingredientList: [],
      isIngredientListLoading: true
    };
  },
  created() {
    globalLoader(true);
    this._loadContent();
  },
  mounted() {},
  watch: {},
  computed: {
    breadcrumbs() {
      return [
        { title: this.$t('catalog'), route: { name: 'products' } },
        { title: this.$t('label.product'), route: { name: 'products' } }
      ];
    }
  },

  methods: {
    ...mapActions({
      getIngredientsLetters: 'ingredients/GET_INGREDIENTS_LETTERS',
      getIngredientsList: 'ingredients/GET_INGREDIENTS',
      getPage: 'staticPages/GET_PAGE'
    }),
    async _loadContent() {
      let promiseCollection = [];
      // let { series } = this.$route.params;
      promiseCollection.push(this.getIngredientsLetters().then((result) => this._prepareLetters(result)));
      promiseCollection.push(this._getList(null));
      promiseCollection.push(
        this.getPage('ingredienty').then((data) => {
          this.ingredientsData = data;
          this._setMetaParams();
        })
      );
      await Promise.all(promiseCollection);
      globalLoader(false);
    },
    _setMetaParams() {
      let { title, metaTitle, metaDescription, image } = this.ingredientsData;
      this.metaParams.title = `${metaTitle || title} ${this.$t('seo.metaTitleGeneral')}`;
      this.metaParams.description = metaDescription || `${metaTitle || title} ${this.$t('seo.metaDescGeneral')}`;
      this.metaParams.image = image || null;
      this.setMeta();
    },
    _prepareLetters(data) {
      this.letterArray = Object.keys(data).reduce(
        (acc, key) => {
          return data[key] ? [...acc, { id: key, title: data[key] }] : acc;
        },
        [{ id: 'all', title: this.$t('page.ingredients.labelAll') }]
      );
    },
    _getList(letter) {
      this.isIngredientListLoading = true;
      this.getIngredientsList(letter ? { letter } : {})
        .then((result) => {
          this.ingredientList = result.data;
        })
        .finally(() => {
          this.isIngredientListLoading = false;
        });
    },
    onChangeLetter() {
      let letter = null;
      if (this.selectedLetter) {
        let letterItem = this.letterArray.find((item) => item.id === this.selectedLetter);
        letter = letterItem && letterItem.id !== 'all' ? letterItem.title : null;
      }
      this._getList(letter);
    }
  }
};
